import { httpResource } from '@angular/common/http';
import { Service, computed, inject, signal } from '@angular/core';
import { UserClient } from '@shared/api/identity/clients/user.client';
import type { UsersMinimalDataResponse } from '@shared/api/identity/dtos/responses/users-minimal-data.response';

@Service()
export class UserReferenceService {
  private readonly client = inject(UserClient);

  private readonly requested = signal(false);

  private readonly request = httpResource<UsersMinimalDataResponse>(() => (this.requested() ? this.client.buildUserLookupRequest() : undefined));

  readonly users = computed(() => (this.request.hasValue() ? (this.request.value().users ?? []) : []));

  readonly isUnavailable = computed(() => this.request.status() === 'error');

  readonly error = this.request.error;

  readonly isLoading = this.request.isLoading;

  load(): void {
    this.requested.set(true);
  }

  reload(): void {
    this.request.reload();
  }

  clear(): void {
    this.requested.set(false);
  }
}
